import {
  Component,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'td-wb-spinner',
  template: `<svg class="td-wb-spinner" viewBox="0 0 52 52" focusable="false" preserveAspectRatio="xMidYMid meet">
              <circle class="td-wb-spinner__circle" cx="26px" cy="26px" r="20px"
                      fill="none" stroke-width="6px" stroke="currentColor">
              </circle>
            </svg>`,
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent {

}
